﻿import {StringNamedValue} from "@2d-front-monorepo/core";
import {QueryAddressesArguments} from "../../types/arguments/QueryAddressesArguments";
import {InstallationByHostData} from "../../types/InstallationByHostData";
import {QueryAddressResult} from "../../types/QueryAddressResult";
import {TimeZone} from "../../types/TimeZone";
import IPermitsGlobal from "../IPermitsGlobal";
import {PermitsFrontClient} from "./PermitsFrontClient";
import {QueryStreetsArguments} from "../../types/arguments/QueryStreetsArguments";
import {QueryStreetsResult} from "../../types/QueryStreetsResult";

export class PermitsGlobal implements IPermitsGlobal {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	streets(data: QueryStreetsArguments, signal?: AbortSignal | undefined): Promise<QueryStreetsResult[]> {
		return this._client.jsonFetch("general/streets", "POST", data, {
			signal: signal
		});
	}

	addresses(data: QueryAddressesArguments, signal?: AbortSignal | undefined): Promise<QueryAddressResult[]> {
		return this._client.jsonFetch("general/addresses", "POST", data, {
			signal: signal
		});
	}

	installation(hostName: string): Promise<InstallationByHostData> {
		return this._client.jsonFetch("installations", "GET", null, {
			query: {
				"hostName": hostName
			}
		});
	}

	groups(group: string, signal?: AbortSignal | undefined): Promise<StringNamedValue[]> {
		return this._client.jsonFetch(`general/lists/${group}`, "GET", null, {
			signal: signal
		});
	}

	timezones(): Promise<TimeZone[]> {
		return this._client.jsonFetch("timezones", "GET", null, null);
	}

	translations(installationId: string, languageId: string): Promise<Record<string, string>> {
		return this._client.jsonFetch(`translations/${installationId}`, "GET", null, {
			query: {
				"languageId": languageId
			}
		});
	}
}
